import type { EditableRegistryElement } from '@/common/utils/editableTableOnChangeRetry'

/** XML элемента из registry: ctx.element (snapshot) или legacy ctx.config.element. */
export function resolveRegistryElementXml(reg: EditableRegistryElement | null | undefined): unknown {
  if (!reg) return undefined
  const ctx = reg.ctx as Record<string, unknown> | undefined
  if (ctx?.element) return ctx.element
  const config = ctx?.config
  if (config && typeof config === 'object') {
    const cfg = config as { element?: unknown }
    if (cfg.element) return cfg.element
    return config
  }
  return (reg as { element?: unknown }).element
}
